/**
 * Lifekline (人生K线) - Types
 * 
 * 前端类型定义，与后端保持一致
 */

// 性别枚举
export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female',
}

/**
 * 八字输入信息
 */
export interface BaziInput {
  name?: string;           // 姓名（可选）
  gender: Gender;          // 性别
  birthYear: string;       // 出生年份 (如 1990)
  yearPillar: string;      // 年柱
  monthPillar: string;     // 月柱
  dayPillar: string;       // 日柱
  hourPillar: string;      // 时柱
  startAge: string;        // 起运年龄 (虚岁)
  firstDaYun: string;      // 第一步大运干支
}

/**
 * K线数据点
 */
export interface KLinePoint {
  age: number;
  year: number;
  ganZhi: string;
  daYun?: string;
  open: number;
  close: number;
  high: number;
  low: number;
  score: number;
  reason: string;
}

/**
 * 命理分析数据
 */
export interface AnalysisData {
  bazi: string[];
  summary: string;
  summaryScore: number;
  personality: string;
  personalityScore: number;
  industry: string;
  industryScore: number;
  fengShui: string;
  fengShuiScore: number;
  wealth: string;
  wealthScore: number;
  marriage: string;
  marriageScore: number;
  health: string;
  healthScore: number;
  family: string;
  familyScore: number;
  crypto: string;
  cryptoScore: number;
  cryptoYear: string;
  cryptoStyle: string;
}

/**
 * 人生K线完整结果
 */
export interface LifeDestinyResult {
  chartData: KLinePoint[];
  analysis: AnalysisData;
}

/**
 * 天干列表
 */
export const TIAN_GAN = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'] as const;

/**
 * 地支列表
 */
export const DI_ZHI = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'] as const;

/**
 * 生成所有干支组合
 */
export function generateGanZhiList(): string[] {
  const result: string[] = [];
  for (let i = 0; i < 60; i++) {
    const gan = TIAN_GAN[i % 10];
    const zhi = DI_ZHI[i % 12];
    if (gan && zhi) {
      result.push(gan + zhi);
    }
  }
  return result;
}

export const GAN_ZHI_LIST = generateGanZhiList();
